import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Chat from "@/pages/Chat";
import Backoffice from "@/pages/Backoffice";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Chat />} />
        <Route path="/backoffice" element={<Backoffice />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}
